// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vx_a bhf_b bhf_wb"};